import { UserDto } from '@ebf/features/users/domain';
import { ChampionshipCategoryDto, ChampionshipRoundDto } from '@ebf/features/championships/domain';
import { FileDto } from '@ebf-libs/sdk/platform/dropzone/lib/domain';
export enum ChampionshipMemberRole {
  CONTESTANT = 'CONTESTANT',
  MODEL = 'MODEL',
  JUDGE = 'JUDGE',
  VENUE_JUDGE = 'VENUE_JUDGE',
}

export interface CategoryMembership {
  readonly number: number;
  readonly category: ChampionshipCategoryDto;
}

export interface ChampionshipMemberCategory {
  readonly category: ChampionshipCategoryDto;
  assignedContestant: Partial<ChampionshipMemberDto>;
  photosBefore: FileDto[];
  photosAfter: FileDto[];
}

export interface ContestantRound {
  readonly round: Pick<ChampionshipRoundDto, 'uuid' | 'title'>;
  /** The list covers every round of the category; a contestant eliminated earlier is not in all of them. */
  readonly participating: boolean;
  readonly photosBeforeEditableByContestant: boolean;
  readonly photosAfterEditableByContestant: boolean;
  readonly photosBefore: FileDto[];
  readonly photosAfter: FileDto[];
  /** Judges assigned to this work and how many are through with it; skipped ones count as done. */
  readonly evaluationsTotal: number;
  readonly evaluationsCompletedTotal: number;
}
export interface ContestantCategory {
  readonly category: Pick<ChampionshipCategoryDto, 'uuid' | 'name'>;
  readonly contestantRounds: ContestantRound[];
}
export interface ChampionshipMemberDto {
  readonly uuid: string;
  readonly number: number;
  readonly judgementNumber?: number;
  readonly user: UserDto;
  readonly type: ChampionshipMemberRole;
  readonly categoryMemberships: CategoryMembership[];
  readonly categories?: Partial<ChampionshipCategoryDto>[];
  readonly assignedContestant?: Partial<ChampionshipMemberDto>;
  readonly contestantCategories?: ContestantCategory[];
  readonly category?: Partial<ChampionshipCategoryDto>;
  readonly fullFaceOnly?: boolean;
  modelCategories: Partial<ChampionshipMemberCategory>[];
  readonly updatedAt: number;
  readonly updatedBy: Partial<UserDto>;
}
